import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ e('<path fill="#FFDA44" d="M11.304 38.016A19.92 19.92 0 0 0 20 40a19.92 19.92 0 0 0 8.696-1.984L30.435 20l-1.74-18.015A19.92 19.92 0 0 0 20 0a19.92 19.92 0 0 0-8.696 1.985L9.565 20l1.74 18.016Z"></path><path fill="#D80027" d="M28.696 38.016C35.386 34.78 40 27.929 40 20c0-7.93-4.614-14.78-11.304-18.015v36.03Z"></path><path fill="#0052B4" d="M11.304 38.016V1.985C4.614 5.219 0 12.07 0 20s4.614 14.78 11.304 18.016Z"></path><path fill="#D80027" d="M20 26.956V20h5.217v2.609c0 .453-.87 2.113-3.015 3.478-.813.517-1.655.683-2.202.87Zm-5.217-12.173H20V20h-5.217v-5.217Z"></path><path fill="#FF9811" d="M22.609 13.043a1.74 1.74 0 0 0-2.61-1.504 1.74 1.74 0 0 0-2.609 1.505h-4.347v8.695c0 3.237 2.571 5.11 4.587 6.08A1.74 1.74 0 0 0 20 30.2a1.74 1.74 0 0 0 2.37-2.381c2.015-.97 4.586-2.843 4.586-6.08v-8.696H22.61Zm1.739 8.696c0 .453 0 1.832-2.146 3.197-.814.517-1.655.852-2.202 1.038a10.534 10.534 0 0 1-2.202-1.038c-2.146-1.365-2.146-2.744-2.146-3.197v-6.087h8.696v6.087Z"></path>', 5), l = [
  h
];
function o(n, p) {
  return t(), a("svg", c, [...l]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
